document.addEventListener("DOMContentLoaded", (fn) => {
  document.querySelectorAll(".shopify-section").forEach((section) => {
    section.setAttribute('x-data', JSON.stringify({
      sectionVisible: false,
    }));
    section.setAttribute("x-intersect.threshold.90", "sectionVisible = true");
  });
});
